import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { OnboardingDialogsContext } from "contexts/OnboardingDialogs";
import { useContext } from "react";
import { useLocation } from "react-router-dom";

import { trackEvent } from "utils/tracking";

interface FillProfileWarningDialogProps {
  open: boolean;
  handleClose: () => void;
}

export default function FillProfileWarningDialog({
  open,
  handleClose,
}: FillProfileWarningDialogProps) {
  const { setProfileDialogOpen } = useContext(OnboardingDialogsContext);
  const location = useLocation();

  const onClose = () => {
    trackEvent("Onboarding Action Items Dialog Closed", {
      route: location.pathname,
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <IconButton
        sx={{
          color: "primary.main",
          fontSize: 14,
          position: "absolute",
          right: 10,
          top: 10,
        }}
        onClick={onClose}
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      <DialogTitle>
        <Grid container justifyContent="center">
          <Typography variant="h5">
            <Box
              component="i"
              className="fa-solid fa-hand"
              sx={{ pr: 0.5, color: "secondary.main" }}
            />{" "}
            Action Items to Complete First!
          </Typography>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ p: 4 }}>
        <Typography paragraph sx={{ mt: 3 }}>
          To get the best brand recommendations, we need to learn more about
          you!
        </Typography>
        <Typography paragraph sx={{ mb: 5 }}>
          Taking just 2 minutes to complete your profile helps us understand
          your preferences and content niche, so we can suggest brands that
          match your work.
        </Typography>
        <Box display="flex" justifyContent="center">
          <Button
            onClick={() => {
              trackEvent("Onboarding Action Items Dialog Get Started Clicked", {
                route: location.pathname,
              });
              setProfileDialogOpen(true);
              handleClose();
            }}
            disableElevation
            variant="contained"
          >
            Get Started
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
